export default "__VITE_ASSET__C8g$IPWp__"